import React from 'react';

export const ME = () => {
	return (
		<svg
			width='20'
			height='15'
			viewBox='0 0 20 15'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
		>
			<g clipPath='url(#clip0_11534_5811)'>
				<mask
					id='mask0_11534_5811'
					style={{ maskType: 'luminance' }}
					maskUnits='userSpaceOnUse'
					x='0'
					y='0'
					width='20'
					height='15'
				>
					<rect width='20' height='15' fill='white' />
				</mask>
				<g mask='url(#mask0_11534_5811)'>
					<path
						fillRule='evenodd'
						clipRule='evenodd'
						d='M0 0H20V15H0V0Z'
						fill='#E8AA00'
					/>
					<path
						fillRule='evenodd'
						clipRule='evenodd'
						d='M2 2H18V13H2V2Z'
						fill='#C51918'
					/>
					<mask
						id='mask1_11534_5811'
						style={{ maskType: 'luminance' }}
						maskUnits='userSpaceOnUse'
						x='2'
						y='2'
						width='16'
						height='11'
					>
						<path
							fillRule='evenodd'
							clipRule='evenodd'
							d='M2 2H18V13H2V2Z'
							fill='white'
						/>
					</mask>
					<g mask='url(#mask1_11534_5811)'>
						<path
							fillRule='evenodd'
							clipRule='evenodd'
							d='M12.6442 9.8446C12.8991 9.8446 13.1058 9.63284 13.1058 9.37162C13.1058 9.11041 12.8991 8.89865 12.6442 8.89865C12.3893 8.89865 12.1827 9.11041 12.1827 9.37162C12.1827 9.63284 12.3893 9.8446 12.6442 9.8446Z'
							fill='#1E5E91'
						/>
						<path
							fillRule='evenodd'
							clipRule='evenodd'
							d='M6.64223 7.7074C5.43146 6.30025 7.16677 3.85826 7.16677 3.85826C7.16677 3.85826 7.4262 5.31673 8.38642 6.29814C8.38642 6.36783 8.29575 6.47065 8.20394 6.57475C8.13983 6.64745 8.07517 6.72077 8.04046 6.78387C7.95604 6.93731 8.24587 7.02478 8.38642 7.02478C8.44951 7.02478 8.48437 7.11627 8.51583 7.19884C8.55446 7.30024 8.58797 7.3882 8.66234 7.27677C8.79728 7.07461 8.5274 6.63042 8.5274 6.63042L8.95463 6.17979L9.09911 5.88849H8.95463V5.58859L8.8534 5.67172C8.8534 5.67172 8.74232 5.40358 8.5274 5.40358C8.31249 5.40358 8.24587 5.28095 8.24587 5.28095H8.5274C8.66838 5.28095 8.50487 5.09414 8.38642 4.99684C8.33333 4.95322 8.25278 4.96826 8.18006 4.98183C8.09056 4.99854 8.01291 5.01304 8.01291 4.91321C8.01291 4.80379 8.09811 4.78929 8.19654 4.77254C8.26088 4.7616 8.33087 4.74969 8.38642 4.70969C8.47831 4.64352 8.60215 4.66387 8.73622 4.68589C8.80723 4.69755 8.88111 4.70969 8.95463 4.70969H9.30273C9.42843 4.70969 9.09911 4.91321 9.09911 4.91321L9.30273 5.09414L9.60553 5.40358L9.4541 5.49345L9.76657 5.79645C9.76657 5.79645 9.6605 5.9689 9.76657 5.9689C9.81028 5.9689 9.83905 6.00473 9.85776 6.04685C9.87648 6.00473 9.90525 5.9689 9.94896 5.9689C10.055 5.9689 9.94896 5.79645 9.94896 5.79645L10.2614 5.49345L10.11 5.40358L10.4128 5.09414L10.6164 4.91321C10.6164 4.91321 10.2871 4.70969 10.4128 4.70969H10.7609C10.8344 4.70969 10.9083 4.69755 10.9793 4.68589C11.1134 4.66387 11.2372 4.64352 11.3291 4.70969C11.3847 4.74969 11.4547 4.7616 11.519 4.77254C11.6174 4.78929 11.7026 4.80379 11.7026 4.91321C11.7026 5.01304 11.625 4.99854 11.5355 4.98183C11.4627 4.96826 11.3822 4.95322 11.3291 4.99684C11.2107 5.09414 11.0471 5.28095 11.1881 5.28095H11.4697C11.4697 5.28095 11.403 5.40358 11.1881 5.40358C10.9732 5.40358 10.8621 5.67172 10.8621 5.67172L10.7609 5.58859V5.88849H10.6164L10.7609 6.17979L11.1881 6.63042C11.1881 6.63042 10.9182 7.07461 11.0532 7.27677C11.1276 7.3882 11.1611 7.30024 11.1997 7.19884C11.2312 7.11627 11.266 7.02478 11.3291 7.02478C11.4697 7.02478 11.7595 6.93731 11.6751 6.78387C11.6404 6.72077 11.5757 6.64745 11.5116 6.57475C11.4198 6.47065 11.3291 6.36783 11.3291 6.29814C12.2893 5.31673 12.5488 3.85826 12.5488 3.85826C12.5488 3.85826 14.2841 6.30025 13.0733 7.7074C11.8625 9.11456 10.9732 8.69024 10.9732 8.69024L11.4697 9.13542L11.3291 9.25705H11.7427L11.5907 9.35875L11.7026 9.40779L11.8211 9.45971C11.8211 9.45971 11.5016 9.69468 11.8211 9.69468C11.8716 9.69468 11.9251 9.69319 11.9801 9.69166C12.0403 9.68999 12.1025 9.68826 12.1646 9.68838C12.1813 9.68841 12.1439 9.59631 12.1068 9.505C12.0702 9.41488 12.034 9.32552 12.0503 9.32622C12.0848 9.32771 12.1527 9.40963 12.2208 9.49183C12.2751 9.55735 12.3295 9.62306 12.3673 9.64836C12.3917 9.66465 12.4868 9.63161 12.5749 9.60099C12.6495 9.57511 12.719 9.55096 12.7366 9.55982C12.8109 9.59732 12.7919 9.6732 12.7738 9.74546C12.7691 9.76404 12.7645 9.78238 12.7616 9.79977C12.7589 9.81557 12.8541 9.75383 12.9542 9.68889C13.0593 9.6207 13.1699 9.54898 13.1783 9.55982C13.1801 9.56209 13.182 9.5644 13.184 9.5668C13.2197 9.6098 13.2773 9.67907 12.8523 10.0066C12.8523 10.0696 12.8545 10.121 12.8564 10.1627C12.8622 10.2968 12.8637 10.3315 12.7729 10.3315C12.7325 10.3315 12.6759 10.3516 12.6103 10.3748C12.4422 10.4344 12.2152 10.5148 12.0503 10.3315C11.8211 10.0767 11.4697 9.69468 11.4697 9.69468V9.88242L11.0532 9.45971L10.9732 9.69468L10.4128 9.05099L10.2614 9.13542C10.2614 9.13542 10.7773 10.559 11.0532 10.5689C11.1903 10.5738 10.9821 10.7069 10.7063 10.8831C10.4271 11.0616 10.0786 11.2843 9.94896 11.4631C9.91038 11.5164 9.88057 11.4352 9.85777 11.2587C9.83496 11.4352 9.80515 11.5164 9.76657 11.4631C9.63693 11.2843 9.28844 11.0616 9.00923 10.8831C8.73343 10.7069 8.52523 10.5738 8.66234 10.5689C8.93826 10.559 9.4541 9.13542 9.4541 9.13542L9.30273 9.05099L8.74232 9.69468L8.66234 9.45971L8.24587 9.88242V9.69468C8.24587 9.69468 7.89438 10.0767 7.66521 10.3315C7.50034 10.5148 7.27331 10.4344 7.10521 10.3748C7.03966 10.3516 6.98307 10.3315 6.94262 10.3315C6.79843 10.3315 6.75017 10.1298 6.94262 9.88242C7.10467 9.67412 7.44214 9.68351 7.73548 9.69166C7.79048 9.69319 7.84393 9.69468 7.89438 9.69468C8.21391 9.69468 7.89438 9.45971 7.89438 9.45971L8.01291 9.40779L8.12488 9.35875L7.97278 9.25705H8.38642L8.24587 9.13542L8.74232 8.69024C8.74232 8.69024 7.85301 9.11456 6.64223 7.7074Z'
							fill='#F6C540'
						/>
						<path
							fillRule='evenodd'
							clipRule='evenodd'
							d='M7.77068 10.644L7.22373 9.68508C7.22373 9.68508 6.50862 8.03627 6.50862 7.83609C6.50862 7.63591 6.22074 7.0431 6.22074 7.21518C6.22074 7.38726 6.22074 7.83609 6.22074 7.83609L7.42729 10.5542V10.7684H7.58977L7.77068 10.644Z'
							fill='#F6C540'
						/>
						<path
							d='M12.1512 9.35308L12.2344 9.07688L13.2505 9.38303L13.1673 9.65923L12.1512 9.35308Z'
							fill='#F6C540'
						/>
						<path
							d='M12.6924 8.85022L12.9672 8.94017L12.6987 9.80143L12.424 9.71148L12.6924 8.85022Z'
							fill='#F6C540'
						/>
						<path
							fillRule='evenodd'
							clipRule='evenodd'
							d='M12.9483 8.56941L12.8892 8.55595L12.8652 8.65096L12.7567 8.6243L12.7433 8.68229L12.8507 8.70864L12.8233 8.81693L12.8824 8.8304L12.9095 8.72308L13.0163 8.7493L13.0296 8.69132L12.9241 8.6654L12.9483 8.56941Z'
							fill='#F6C540'
						/>
						<path
							fillRule='evenodd'
							clipRule='evenodd'
							d='M9.809 3.26402L9.83871 3.36765H9.92895L9.95866 3.26402C10.0337 3.28662 10.1019 3.31234 10.1629 3.34105L10.165 3.31836C10.6474 3.36242 10.8977 3.56434 10.8709 3.91936C10.8487 4.21324 10.6999 4.3672 10.4519 4.36326V4.58277C10.4519 4.58277 10.0481 4.73779 9.84615 4.73779C9.64422 4.73779 9.24038 4.58277 9.24038 4.58277V4.35954C9.03614 4.33429 8.91418 4.18323 8.89424 3.91936C8.86741 3.56434 9.11774 3.36242 9.60013 3.31836L9.60234 3.34218C9.66401 3.31301 9.73293 3.28691 9.809 3.26402ZM9.29831 4.16669C9.27112 4.17431 9.25201 4.17992 9.24424 4.18223C9.13349 4.16146 9.07943 4.07296 9.06687 3.90672C9.05416 3.73866 9.13313 3.62173 9.31931 3.55429C9.19229 3.71687 9.18297 3.92367 9.29831 4.16669ZM9.47027 4.1219C9.57206 4.09744 9.68982 4.07313 9.78416 4.06477V3.4581C9.39677 3.59406 9.30371 3.80204 9.47027 4.1219ZM9.95724 4.07023C10.0871 4.08725 10.2447 4.12625 10.3466 4.15368L10.2955 4.12549C10.4684 3.79648 10.3681 3.58537 9.95724 3.44915V4.07023ZM10.4493 3.55557C10.5789 3.72246 10.5848 3.93581 10.4595 4.187C10.6121 4.18929 10.6836 4.10121 10.6983 3.90672C10.7109 3.73971 10.633 3.6232 10.4493 3.55557Z'
							fill='#F6C540'
						/>
						<path
							fillRule='evenodd'
							clipRule='evenodd'
							d='M9.84615 3.44945C9.95767 3.44945 10.0481 3.35905 10.0481 3.24753C10.0481 3.13601 9.95767 3.04561 9.84615 3.04561C9.73463 3.04561 9.64423 3.13601 9.64423 3.24753C9.64423 3.35905 9.73463 3.44945 9.84615 3.44945Z'
							fill='#3D58DB'
						/>
						<path
							fillRule='evenodd'
							clipRule='evenodd'
							d='M9.87428 2.8114L9.81371 2.81263L9.81341 2.91063L9.70163 2.91102L9.70271 2.97051L9.81322 2.97012L9.81287 3.08181L9.87344 3.08059L9.87378 2.9699L9.98375 2.96951L9.98266 2.91002L9.87397 2.91041L9.87428 2.8114Z'
							fill='#F6C540'
						/>
						<path
							fillRule='evenodd'
							clipRule='evenodd'
							d='M8.72114 6.47466C8.72114 6.47466 9.4322 6.34048 9.8173 6.34048C10.163 6.34048 10.9135 6.47466 10.9135 6.47466C10.9135 7.32469 11.1527 7.8451 10.9135 8.42568C10.6742 9.00625 10.0897 8.72717 9.8251 9.28275C9.48696 8.75577 9.03031 9.04584 8.72114 8.29545C8.41197 7.54506 8.9091 7.19945 8.72114 6.47466Z'
							fill='#1E5E91'
						/>
						<mask
							id='mask2_11534_5811'
							style={{ maskType: 'luminance' }}
							maskUnits='userSpaceOnUse'
							x='8'
							y='6'
							width='4'
							height='4'
						>
							<path
								fillRule='evenodd'
								clipRule='evenodd'
								d='M8.72114 6.47466C8.72114 6.47466 9.4322 6.34048 9.8173 6.34048C10.163 6.34048 10.9135 6.47466 10.9135 6.47466C10.9135 7.32469 11.1527 7.8451 10.9135 8.42568C10.6742 9.00625 10.0897 8.72717 9.8251 9.28275C9.48696 8.75577 9.03031 9.04584 8.72114 8.29545C8.41197 7.54506 8.9091 7.19945 8.72114 6.47466Z'
								fill='white'
							/>
						</mask>
						<g mask='url(#mask2_11534_5811)'>
							<rect
								x='8.72115'
								y='8.24831'
								width='2.19231'
								height='1.06419'
								fill='#5EAA22'
							/>
							<path
								fillRule='evenodd'
								clipRule='evenodd'
								d='M9.36933 6.89356C9.28555 6.71552 9.80952 6.69481 9.80952 6.69481C9.80952 6.69481 9.92251 6.89356 9.80952 7.17636C9.72735 7.38203 9.8644 7.36369 10.0535 7.33839C10.1244 7.3289 10.2026 7.31843 10.2794 7.31843C10.3969 7.31843 10.4588 7.30981 10.5101 7.32911C10.5817 7.35601 10.633 7.43715 10.7861 7.67143C10.8561 7.7784 10.853 7.84885 10.8108 7.89097C10.8145 7.9998 10.696 8.09001 10.4771 8.14775L10.4483 8.03325C10.5641 8.0027 10.635 7.97349 10.668 7.9412C10.503 7.95125 10.2794 7.86971 10.2794 7.76494C10.2794 7.61001 9.75128 7.64264 9.43349 7.66227C9.35253 7.66727 9.28523 7.67143 9.24377 7.67143C9.05895 7.67143 9.20066 7.44555 9.32962 7.24C9.34313 7.21847 9.3565 7.19716 9.36933 7.17636C9.43557 7.06904 9.45705 7.04164 9.45191 7.02082C9.44654 6.99908 9.41213 6.9845 9.36933 6.89356ZM10.6263 6.86599C10.3097 6.81575 10.1321 6.86436 10.1321 7.04148C10.1321 7.21008 10.3006 7.28319 10.6089 7.28206C10.6208 7.28597 10.6314 7.28983 10.6404 7.29357C10.6289 7.29902 10.6148 7.3048 10.5983 7.31075L10.6366 7.42229C10.8309 7.35222 10.8309 7.22753 10.6342 7.16631L10.6258 7.16369L10.617 7.16377C10.3608 7.16589 10.2475 7.11783 10.2475 7.04148C10.2475 6.97202 10.355 6.94259 10.6086 6.98284L10.6263 6.86599Z'
								fill='#F6C540'
							/>
						</g>
					</g>
				</g>
			</g>
			<rect
				x='0.5'
				y='0.5'
				width='19'
				height='14'
				rx='1'
				stroke='black'
				strokeOpacity='0.1'
			/>
			<defs>
				<clipPath id='clip0_11534_5811'>
					<rect width='20' height='15' rx='1.5' fill='white' />
				</clipPath>
			</defs>
		</svg>
	);
};
